
import {  appConst, Component, FormModalMixins, FactoryDomesticSourceMixin } from "@/lib";
import DeclareGroup from "@/store/modules/shipment/declaregroup/entity";
import DeclareProductList from "@/store/modules/shipment/declareproductlist/entity";

class EditRow {
  index: number;
  data: DeclareProductList;
  isAdd: boolean;

  constructor() {
    this.index = -1;
    this.data = new DeclareProductList();
    this.isAdd = false;
  }
}

@Component({
  mixins: [FactoryDomesticSourceMixin]
})
export default class CreateDeclareGroupModel extends FormModalMixins {
  model:DeclareGroup = new DeclareGroup();

  editRow:EditRow = new EditRow();

  get record(){
    let result = this.$store.state.shipment.declaregroup.editDeclareGroup as DeclareGroup;
    if (result.productList.length == 0) {
      result.productList.push(new DeclareProductList());

      this.editRow.index = result.productList.length - 1;
      this.editRow.isAdd = true;
      this.editRow.data = new DeclareProductList();
    }
    return result;
  }

  get sizeUnit() {
    return this.setSizeUnit(this.editRow.data.unit);
  }

  get dotNumber():number {
    return this.setdotNumber(this.sizeUnit);
  }

  setSizeUnit(unit) {
    return unit === this.$appconst.unit.size;
  }
  setdotNumber(isSizeUnit) {
    return isSizeUnit ? 2 : 0;
  }

  quantity(row) {
    let dotNumber = this.setdotNumber(this.setSizeUnit(row.unit));
    return !!row.quantity || row.quantity === 0 ? row.quantity.toFixed(dotNumber) : row.quantity
  }

  created() {
    Object.assign(this.config,{
        labelWidth: 80,
        width: 1600
    })
    this.loadFactorySelectOptions();
  }

  get modelTitleL() {
    return this.model.editRowIndex > -1 ? "app.Title.EditDetail" : "app.Title.AddDetail";
  }

  get column() {
    return [
      this.$util.render.baseColumn("app.DeclareGroup.ProductName", null, {key: "productName", slot: "productName", minWidth: 210, className: "hi-table-edit-cell"}),
      this.$util.render.baseColumn("app.DeclareGroup.ProductNameEn", null, {key: "productNameEn", slot: "productNameEn", minWidth: 170, className: "hi-table-edit-cell"}),
      this.$util.render.baseColumn("app.DeclareGroup.BoxCount", null, {key: "boxCount", slot: "boxCount", width: 100, align: 'right', className: "hi-table-edit-cell"}),
      this.$util.render.baseColumn("app.DeclareGroup.Quantity", null, {key: "quantity", slot: "quantity", width: 100, align: 'right', className: "hi-table-edit-cell"}),
      this.$util.render.baseColumn("app.DeclareGroup.Unit", null, {key: "unit", slot: "unit", minWidth: 110, className: "hi-table-edit-cell"}),
      this.$util.render.baseColumn("app.DeclareGroup.GrossWeight", null, {key: "grossWeight", slot: "grossWeight", width: 100, align: 'right', className: "hi-table-edit-cell"}),
      this.$util.render.baseColumn("app.DeclareGroup.TotalGrossWeight", null, {key: "totalGrossWeight", slot: "totalGrossWeight", minWidth: 120, align: 'right', className: "hi-table-edit-cell"}),
      this.$util.render.baseColumn("app.DeclareGroup.NetWeight", null, {key: "netWeight", slot: "netWeight", width: 100, align: 'right', className: "hi-table-edit-cell"}),
      this.$util.render.baseColumn("app.DeclareGroup.TotalNetWeight", null, {key: "totalNetWeight", slot: "totalNetWeight", minWidth: 120, align: 'right', className: "hi-table-edit-cell"}),
      this.$util.render.baseColumn("app.DeclareGroup.Price", null, {key: "price", slot: "price", minWidth: 100, align: 'right', className: "hi-table-edit-cell"}),
      this.$util.render.baseColumn("app.DeclareGroup.TotalAmount", null, {key: "totalAmount", slot: "totalAmount", minWidth: 140, align: 'right', className: "hi-table-edit-cell"}),
      // this.$util.render.baseColumn("app.DeclareGroup.ProductCode", null, {key: "productCode", slot: "productCode", minWidth: 120}),
      this.$util.render.baseColumn("app.Factory.FactoryName", null, {key: "factoryId", slot: "factoryId", width: 120, className: "hi-table-edit-cell"}),
      this.$util.render.baseColumn("app.DeclareGroup.RmbAmount", null, {key: "rmbAmount", slot: "rmbAmount", minWidth: 130, align: 'right', className: "hi-table-edit-cell"}),
      this.$util.render.baseColumn("app.DeclareCustoms.DomesticSourceOfGood", null, {key: "domesticSourceOfGood", slot: "domesticSourceOfGood", width: 96, className: "hi-table-edit-cell"}),
      this.$util.render.baseColumn("Action.Actions", null, {key: "actions", slot: "actions", width: 100, fixed: 'right'})
    ];
  }

  get productList() {
    return this.$store.state.system.productname.productNameSelect;
  }

  get unitList() {
    return this.getCodeListByCategory(appConst.codeCategory.unit)
  }

  get rules() {
    return {
      select: [
        {
          required: true,
          type: "number",
          message: this.L("Validate.PleaseSelect"),
          trigger: "change"
        }
      ],
      selectOfString: [
        {
          required: true,
          type: "string",
          message: this.L("Validate.PleaseSelect"),
          trigger: "change"
        }
      ],
      inputNumber: [
        {
          required: true,
          type: "number",
          message: this.L("Validate.PleaseInput"),
          trigger: "blur"
        }
      ],
      input: [
        {
          required: true,
          type: "string",
          message: this.L("Validate.PleaseInput"),
          trigger: "blur"
        }
      ],
      factorySelect: [
        {
          type: "number",
          trigger: "change",
          validator: (rule, value, callback) => {
            if (!value || value <= 0) {
              return callback(new Error(this.L("Validate.PleaseSelect")));
            }
            callback();
          }
        }
      ],
      grossWeight: this.validateSpecialNumber("totalGrossWeight"),
      netWeight: this.validateSpecialNumber("totalNetWeight"),
      price: this.validateSpecialNumber("totalAmount"),
    }
  }

  // 编辑行的箱数，当该行没有填箱数的时候，取第一行的箱数
  get editRowBoxCount () {
    if (!!this.editRow.data.boxCount || this.editRow.data.boxCount === 0) {
      return this.editRow.data.boxCount;
    }
    if (this.model.productList && this.model.productList.length > 0) {
      return this.model.productList[0].boxCount;
    }
    return null;
  }

  validateSpecialNumber(totalKey) {
    const text = this.L("Validate.PleaseInput");
    return [
      {
        type: "number",
        trigger: "blur",
        validator: (rule, value, callback) => {
          if ((!value && value !== 0) && !this.editRow.data[totalKey] && this.editRow.data[totalKey] !== 0) {
              return callback(new Error(text));
          }
          callback();
        }
      }
    ]
  }

  handleAdd() {
    if (this.editRow.index > -1) {
      this.handleSave(this.editRow.index, () => this.setAddRow());
      return;
    }
    this.setAddRow();
  }

  setAddRow() {
    this.model.productList.push(new DeclareProductList());

    this.editRow.index = this.model.productList.length - 1;
    this.editRow.isAdd = true;
    this.editRow.data = new DeclareProductList();
  }

  /**
   * 编辑
   */
  handleEdit(row, index) {
    if (this.editRow.index > -1) {
      this.handleSave(this.editRow.index, () => this.setEditRow(row, index));
      return;
    }
    this.setEditRow(row, index);
  }

  setEditRow(row, index) {
    this.editRow.index = index;
    this.editRow.isAdd = false;
    this.editRow.data.productId = row.productId;
    this.editRow.data.productName = row.productName;
    this.editRow.data.productNameEn = row.productNameEn;
    this.editRow.data.boxCount = row.boxCount;
    this.editRow.data.quantity = row.quantity;
    this.editRow.data.unit = row.unit;
    this.editRow.data.grossWeight = row.grossWeight;
    this.editRow.data.totalGrossWeight = row.totalGrossWeight;
    this.editRow.data.netWeight = row.netWeight;
    this.editRow.data.totalNetWeight = row.totalNetWeight;
    this.editRow.data.price = row.price;
    this.editRow.data.totalAmount = row.totalAmount;
    this.editRow.data.productCode = row.productCode;
    this.editRow.data.factoryId = row.factoryId || 0;
    this.editRow.data.factoryName = row.factoryName;
    this.editRow.data.domesticSourceOfGood = row.domesticSourceOfGood;
    this.editRow.data.rmbAmount = row.rmbAmount;
  }

  /**
   * 删除
   */
  handleDelete(index) {
    this.model.productList.splice(index, 1);
  }
  /**
   * 保存
   */
  handleSave(index, callback = null) {
    (this.$refs["list-table-form"] as any).validate(async (valid: boolean) => {
      if (valid) {
        this.$set(this.model.productList[index], "productId", this.editRow.data.productId);
        this.$set(this.model.productList[index], "productName", this.editRow.data.productName);
        this.$set(this.model.productList[index], "productNameEn", this.editRow.data.productNameEn);
        this.$set(this.model.productList[index], "boxCount", this.editRow.data.boxCount);
        this.$set(this.model.productList[index], "quantity", this.editRow.data.quantity);
        this.$set(this.model.productList[index], "unit", this.editRow.data.unit);
        this.$set(this.model.productList[index], "grossWeight", this.editRow.data.grossWeight);
        this.$set(this.model.productList[index], "totalGrossWeight", this.editRow.data.totalGrossWeight);
        this.$set(this.model.productList[index], "netWeight", this.editRow.data.netWeight);
        this.$set(this.model.productList[index], "totalNetWeight", this.editRow.data.totalNetWeight);
        this.$set(this.model.productList[index], "price", this.editRow.data.price);
        this.$set(this.model.productList[index], "totalAmount", this.editRow.data.totalAmount);
        this.$set(this.model.productList[index], "productCode", this.editRow.data.productCode);
        this.$set(this.model.productList[index], "factoryId", this.editRow.data.factoryId || 0);
        this.$set(this.model.productList[index], "factoryName", this.editRow.data.factoryName);
        this.$set(this.model.productList[index], "domesticSourceOfGood", this.editRow.data.domesticSourceOfGood);
        this.$set(this.model.productList[index], "rmbAmount", this.editRow.data.rmbAmount);
        
        // 如果修改的是第一条数据的箱数，则同步更新其他无箱数的数据
        if (index === 0 && (!!this.editRowBoxCount || this.editRowBoxCount === 0)) {
          this.model.productList.forEach((element, index) => {
            if (index !== 0 && !element.boxCount && element.boxCount !== 0) {
              if (!!element.grossWeight || element.grossWeight === 0) {
                element.totalGrossWeight = element.grossWeight * this.editRowBoxCount;
              }
              if (!!element.netWeight || element.netWeight === 0) {
                element.totalNetWeight = element.netWeight * this.editRowBoxCount;
              }
            }
          });
        }
        this.handleCancel();

        if (callback) {
          callback();
        }
      }
    });
  }
  /**
   * 取消
   */
  handleCancel(index = -1) {
    if (this.editRow.isAdd && index > -1) {
      this.handleDelete(index);
    }
    this.editRow.index = -1;
    this.editRow.isAdd = false;
    this.editRow.data = new DeclareProductList();
  }
  /**
   * 产品修改
   */
  productChange(value) {
    let selectedItem = this.productList.find(x => x.value == value);
    if (selectedItem) {
      this.editRow.data.productName = selectedItem.name;
      this.editRow.data.productNameEn = selectedItem.nameEn;
      this.editRow.data.productCode = selectedItem.code;
      this.editRow.data.unit = selectedItem.unit;

      (this.$refs["list-table-form"] as any).validateField('productNameEn');
      (this.$refs["list-table-form"] as any).validateField('unit');
    } else {
      this.editRow.data.productName = null;
      this.editRow.data.productNameEn = null;
      this.editRow.data.productCode = null;
      this.editRow.data.unit = null;
    }
    
  }
  /** 
   * 箱数(CTN)修改
   * 每箱毛重/毛重，每箱净重/净重以及单价/总价，若输入对应的每箱或单价值，则自动根据公式*箱数，计算出毛重/净重/总价。若手工录入后面的毛重/净重/总价,则前面的每箱/单价自动清空
   */
  boxCountChange(value) {
    // 毛重
    if (this.editRow.data.grossWeight) {
      this.editRow.data.totalGrossWeight = this.editRow.data.grossWeight * this.editRowBoxCount;
      // this.$set(this.editRow.data, "totalGrossWeight", this.editRow.data.grossWeight * this.editRowBoxCount);
    }
    // 净重
    if (this.editRow.data.netWeight) {
      this.editRow.data.totalNetWeight = this.editRow.data.netWeight * this.editRowBoxCount;
    }
  }

  quantityChange() {
    // 总价
    if (this.editRow.data.price) {
      this.editRow.data.totalAmount = this.editRow.data.price * this.editRow.data.quantity;
    }
  }
  /** 
   * 每箱毛重修改
   */
  grossWeightChange(value) {
    if (this.editRowBoxCount) {
      this.editRow.data.totalGrossWeight = this.editRow.data.grossWeight * this.editRowBoxCount;
    }
  }
  /** 
   * 毛重修改
   */
  totalGrossWeightChange(value) {
    this.editRow.data.grossWeight = null;
    (this.$refs["list-table-form"] as any).validateField("grossWeight");
  }
  /** 
   * 每箱净重修改
   */
  netWeightChange(value) {
    if (this.editRowBoxCount) {
      this.editRow.data.totalNetWeight = this.editRow.data.netWeight * this.editRowBoxCount;
    }
  }
  /** 
   * 净重（KGS)修改
   */
  totalNetWeightChange(value) {
    this.editRow.data.netWeight = null;
    (this.$refs["list-table-form"] as any).validateField("netWeight");
  }
  /** 
   * 单价修改
   */
  priceChange(value) {
    if (this.editRow.data.quantity) {
      this.editRow.data.totalAmount = this.editRow.data.price * this.editRow.data.quantity;
    }
  }
  /** 
   * 总价修改
   */
  totalAmountChange(value) {
    this.editRow.data.price = null;
    (this.$refs["list-table-form"] as any).validateField("price");
  }

  rowClassName (row, index) {
    if (index === this.editRow.index) {
      return 'hi-table-error-row';
    }
    return '';
  }

  close() {
    this.config.isShow = false;
    this.model = new DeclareGroup();
    this.handleCancel();
  }

  handleSummary ({ columns, data }) {
    const sums = {};
    const totalText = this.L('app.Common.Total');
    const NA = 'N/A';
    columns.forEach((column, index) => {
        const key = column.key;
        if (key === 'productNameEn' || key === 'unit' || key === 'grossWeight' || key === 'netWeight' || key === 'price' || key === 'rmbAmount' || key === 'productCode' || key === 'factoryId' || key === 'domesticSourceOfGood' || key === 'actions') {
            sums[key] = {
                key,
                value: ''
            };
            return;
        }
        if (index === 0) {
            sums[key] = {
                key,
                value: totalText
            };
            return;
        }
        let haveSizeUnit = (data as Array<any>).some((item)=> {
          return this.setSizeUnit(item.unit);
        });
        let dotNumber = this.setdotNumber(haveSizeUnit);
        const values = data.map(item => Number(item[key]));
        if (!values.every(value => isNaN(value))) {
            const v = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                    return prev + curr;
                } else {
                    return prev;
                }
            }, 0);
            let amountText = "";
            switch(key) {
              case "totalAmount": 
                amountText = this.$util.format.amount(v);
                break;
              case "boxCount":
                amountText = v.toFixed(0);
                break;
              case "quantity":
                amountText = v.toFixed(dotNumber);
                break;
              default:
                amountText = v.toFixed(2);
                break;
            }
            sums[key] = {
                key,
                value: amountText
            };
        } else {
            sums[key] = {
                key,
                value: NA
            };
        }
    });

    return sums;
  }

  validateForm(value:any){
    if (this.editRow.index > -1) {
      this.handleSave(this.editRow.index, () => this.saveSuccess(value));
      return;
    }
    this.saveSuccess(value);
  }
}

